/* eslint-disable */
import { jwtDecode } from 'jwt-decode';
import { lazy, Suspense, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';

import DashboardLayout from 'src/layouts/dashboard';

export const IndexPage = lazy(() => import('src/pages/app'));
export const ListSignup = lazy(() => import('src/pages/listSignup'));
export const UserPage = lazy(() => import('src/pages/user'));
export const ManageDept = lazy(() => import('src/pages/manageDept'));
export const ManageAssets = lazy(() => import('src/pages/manageAssets'));
export const ManageChatId = lazy(() => import('src/pages/manageChatId'));
export const ManageEmployee = lazy(() => import('src/pages/manageEmployee'));
export const ManageAdOrganization = lazy(() => import('src/pages/manageAdOrganization'));
export const ManageBranch = lazy(() => import('src/pages/manageBranch'));
export const ListRecruit = lazy(() => import('src/pages/listRecruit'));
export const ListSignUp = lazy(() => import('src/pages/listSignup'));
export const ManageUser = lazy(() => import('src/pages/manageUser'));
export const ManageHealth = lazy(() => import('src/pages/manageHealth'));
export const EmployeeDamageOrLoan = lazy(() => import('src/pages/employeeDamageOrLoan'));
export const DeptOpen = lazy(() => import('src/pages/deptOpen'));
export const ReqEmployee = lazy(() => import('src/pages/reqEmployee'));
export const SettingTest = lazy(() => import('src/pages/settingTest'));
export const MyCalendar = lazy(() => import('src/pages/myCalendar'));
export const ApproveReqList = lazy(() => import('src/pages/approveReqList'));
export const ManageTest = lazy(() => import('src/pages/manageTest'));
export const Candidate = lazy(() => import('src/pages/candidate'));
export const CardBusiness = lazy(() => import('src/pages/cardBusiness'));
export const EMCardBusiness = lazy(() => import('src/pages/emCardBusiness'));
export const LoginPage = lazy(() => import('src/pages/login'));
export const Profile = lazy(() => import('src/pages/profile'));
export const LoginCandidate = lazy(() => import('src/pages/loginCandidate'));
export const DeptOnOpen = lazy(() => import('src/pages/deptOnOpen'));
export const ManageDoc = lazy(() => import('src/pages/manageDoc'));
export const ProbationEva = lazy(() => import('src/pages/testProbationEva'));
export const ProbationEvaMe = lazy(() => import('src/pages/testProbationEvaMe'));
export const TestProbationEva = lazy(() => import('src/pages/testProbationEva'));
export const TestProbationEvaYear = lazy(() => import('src/pages/testProbationEvaYear'));
export const TestTalentAssessment = lazy(() => import('src/pages/testTalentAssessment'));
export const BehaviorDisciplineEvaYear = lazy(() => import('src/pages/behaviorDisciplineEvaYear'));
export const RegisterCandidate = lazy(() => import('src/pages/registerCandidate'));
export const ManageWelfare = lazy(() => import('src/pages/manageWelfare'));
export const ProductsPage = lazy(() => import('src/pages/products'));
export const DashboardProbationEva = lazy(() => import('src/pages/dashboardProbationEva'));
export const DashboardProbationEvaYear = lazy(() => import('src/pages/dashboardProbationEvaYear'));
export const ProbationEvaYear = lazy(() => import('src/pages/testProbationEvaYear'));
export const ProbationEvaYearMe = lazy(() => import('src/pages/probationEvaYearMe'));
export const SummaryProbationEvaYear = lazy(() => import('src/pages/summaryProbationEvaYear'));
export const SummaryKpiProbationEvaYear = lazy(() => import('src/pages/summaryKpiProbationEvaYear'));
export const ReportEvaluation = lazy(() => import('src/pages/reportEvaluation'));
export const ReportEmployee = lazy(() => import('src/pages/reportEmployee'));
export const CandidateEvaluation = lazy(() => import('src/pages/candidateEvaluation'));
export const ApplicationArchive = lazy(() => import('src/pages/applicationArchive'));
export const TrainingHistory = lazy(() => import('src/pages/trainingHistory'));
export const TrainingRequest = lazy(() => import('src/pages/trainingRequest'));
export const TrainingData = lazy(() => import('src/pages/trainingData'));
export const TrainingPlan = lazy(() => import('src/pages/trainingPlan'));
export const TrainingSkillNeed = lazy(() => import('src/pages/trainingSkillNeed'));
export const TrainingCompliance = lazy(() => import('src/pages/trainingCompliance'));
export const TrainingDsd = lazy(() => import('src/pages/trainingDsd'));
export const TrainingCertificate = lazy(() => import('src/pages/trainingCertificate'));
export const EvaluationSkillGap = lazy(() => import('src/pages/evaluationSkillGap'));
export const TalentNineBox = lazy(() => import('src/pages/talentNineBox'));
export const EvaluationRetention = lazy(() => import('src/pages/evaluationRetention'));
export const EvaluationOkr = lazy(() => import('src/pages/evaluationOkr'));
export const EvaluationPeerSummary = lazy(() => import('src/pages/evaluationPeerSummary'));
export const BoonsiriConnect = lazy(() =>
  import('src/pages/phase3Shells').then((m) => ({ default: m.BoonsiriConnectPage }))
);
export const BaiboonAdmin = lazy(() => import('src/pages/baiboonAdmin'));
export const DataGovernance = lazy(() =>
  import('src/pages/phase3Shells').then((m) => ({ default: m.DataGovernancePage }))
);
export const OtCosting = lazy(() => import('src/pages/otCosting'));
export const ResetPassword = lazy(() => import('src/pages/resetPassword'));
export const DocOther = lazy(() => import('src/pages/docOther'));
export const Document = lazy(() => import('src/pages/document'));
export const Claim = lazy(() => import('src/pages/claim'));
export const Reward = lazy(() => import('src/pages/reward'));
export const Consent = lazy(() => import('src/pages/consent'));
export const Employee = lazy(() => import('src/pages/employee'));
export const OrganizationalChart = lazy(() => import('src/pages/organizationalChart'));
export const Resignation = lazy(() => import('src/pages/resignation'));
export const TransferRequest = lazy(() => import('src/pages/transferRequest'));
export const FavoriteJob = lazy(() => import('src/pages/favoriteJob'));
export const ReportResign = lazy(() => import('src/pages/reportResign'));
export const PrepareAssignAsset = lazy(() => import('src/pages/prepareAssignAsset'));
export const LeaderBoard = lazy(() => import('src/pages/leaderBoard'));
export const Orientation = lazy(() => import('src/pages/orientation'));
export const ReqEditCalendar = lazy(() => import('src/pages/reqEditCalendar'));
export const ResignationList = lazy(() => import('src/pages/resignationList'));
export const Test = lazy(() => import('src/pages/test'));
export const TestQuestions = lazy(() => import('src/pages/testQuestions'));
export const Resume = lazy(() => import('src/pages/resume'));
export const PromoteCandidate = lazy(() => import('src/pages/promoteCandidate'));
export const EmployeeIdCard = lazy(() => import('src/pages/employeeIdCard'));
export const MySignaturePage = lazy(() => import('src/pages/mySignature'));
export const Page404 = lazy(() => import('src/pages/page-not-found'));

// ----------------------------------------------------------------------

export default function Router() {
  const [cookies, setCookie] = useCookies(['session']);
  const sessionToken = cookies?.session;
  const [candidate, setCandidate] = useState(null);
  console.log('🚀 ~ Router ~ candidate:', candidate);

  useEffect(() => {
    // ตรวจสอบและถอดรหัส token
    let decodedToken = null;
    try {
      if (sessionToken && typeof sessionToken === 'string') {
        decodedToken = jwtDecode(sessionToken);
      } else {
        console.warn('Invalid or missing session cookie');
      }
    } catch (error) {
      console.error('Error decoding token:', error.message);
    }

    // หา employeeId ตาม userId
    if (decodedToken) {
      setCandidate(decodedToken);
    }
  }, [sessionToken]);
  const routes = useRoutes([
    {
      element: !cookies.session ? (
        <Suspense>
          <Outlet />
        </Suspense>
      ) : (
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        {
          element:
            cookies.session && !candidate?.candidateId ? (
              !cookies.session ? (
                <LoginPage />
              ) : (
                <IndexPage />
              )
            ) : !cookies.session ? (
              <LoginPage />
            ) : (
              <DeptOnOpen />
            ),
          index: true,
        },
        { path: 'user', element: !cookies.session ? <LoginPage /> : <UserPage /> },
        { path: 'products', element: !cookies.session ? <LoginPage /> : <ProductsPage /> },
        { path: 'manageDept', element: !cookies.session ? <LoginPage /> : <ManageDept /> },
        { path: 'manageEmployee', element: !cookies.session ? <LoginPage /> : <ManageEmployee /> },
        {
          path: 'manageAdOrganization',
          element: !cookies.session ? <LoginPage /> : <ManageAdOrganization />,
        },
        { path: 'manageBranch', element: !cookies.session ? <LoginPage /> : <ManageBranch /> },
        { path: 'testQuestions', element: !cookies.session ? <LoginPage /> : <TestQuestions /> },
        { path: 'myCalendar', element: !cookies.session ? <LoginPage /> : <MyCalendar /> },
        { path: 'manageUser', element: !cookies.session ? <LoginPage /> : <ManageUser /> },
        { path: 'manageTest', element: !cookies.session ? <LoginPage /> : <ManageTest /> },
        { path: 'manageHealth', element: !cookies.session ? <LoginPage /> : <ManageHealth /> },
        { path: 'employeeDamageOrLoan', element: !cookies.session ? <LoginPage /> : <EmployeeDamageOrLoan /> },
        { path: 'manageWelfare', element: !cookies.session ? <LoginPage /> : <ManageWelfare /> },
        {
          path: 'reqEditCalendar',
          element: !cookies.session ? <LoginPage /> : <ReqEditCalendar />,
        },
        { path: 'reqEmployee', element: !cookies.session ? <LoginPage /> : <ReqEmployee /> },
        { path: 'approveReqList', element: !cookies.session ? <LoginPage /> : <ApproveReqList /> },
        { path: 'leaderBoard', element: !cookies.session ? <LoginPage /> : <LeaderBoard /> },
        { path: 'deptOpen', element: !cookies.session ? <LoginPage /> : <DeptOpen /> },
        { path: 'consent', element: !cookies.session ? <LoginPage /> : <Consent /> },
        {
          path: 'prepareAssignAsset',
          element: !cookies.session ? <LoginPage /> : <PrepareAssignAsset />,
        },
        { path: 'deptOnOpen', element: !cookies.session ? <LoginPage /> : <DeptOnOpen /> },
        { path: 'profile', element: !cookies.session ? <LoginPage /> : <Profile /> },
        { path: 'employeeIdCard', element: !cookies.session ? <LoginPage /> : <EmployeeIdCard /> },
        { path: 'mySignature', element: !cookies.session ? <LoginPage /> : <MySignaturePage /> },
        { path: 'listRecruit', element: !cookies.session ? <LoginPage /> : <ListRecruit /> },
        {
          path: 'applicationArchive',
          element: !cookies.session ? <LoginPage /> : <ApplicationArchive />,
        },
        {
          path: 'summaryProbationEvaYear',
          element: !cookies.session ? <LoginPage /> : <SummaryProbationEvaYear />,
        },
        {
          path: 'behaviorDisciplineEvaYear',
          element: !cookies.session ? <LoginPage /> : <BehaviorDisciplineEvaYear />,
        },
        {
          path: 'summaryKpiProbationEvaYear',
          element: !cookies.session ? <LoginPage /> : <SummaryKpiProbationEvaYear />,
        },
        { path: 'docOther', element: !cookies.session ? <LoginPage /> : <DocOther /> },
        { path: 'settingTest', element: !cookies.session ? <LoginPage /> : <SettingTest /> },
        { path: 'document', element: !cookies.session ? <LoginPage /> : <Document /> },
        {
          path: 'candidateEvaluation',
          element: !cookies.session ? <LoginPage /> : <CandidateEvaluation />,
        },
        { path: 'manageDoc', element: !cookies.session ? <LoginPage /> : <ManageDoc /> },
        { path: 'resignation', element: !cookies.session ? <LoginPage /> : <Resignation /> },
        {
          path: 'transferRequest',
          element: !cookies.session ? <LoginPage /> : <TransferRequest />,
        },
        {
          path: 'trainingHistory',
          element: !cookies.session ? <LoginPage /> : <TrainingHistory />,
        },
        {
          path: 'trainingRequest',
          element: !cookies.session ? <LoginPage /> : <TrainingRequest />,
        },
        {
          path: 'trainingData',
          element: !cookies.session ? <LoginPage /> : <TrainingData />,
        },
        {
          path: 'trainingPlan',
          element: !cookies.session ? <LoginPage /> : <TrainingPlan />,
        },
        {
          path: 'trainingSkillNeed',
          element: !cookies.session ? <LoginPage /> : <TrainingSkillNeed />,
        },
        {
          path: 'trainingCompliance',
          element: !cookies.session ? <LoginPage /> : <TrainingCompliance />,
        },
        {
          path: 'trainingDsd',
          element: !cookies.session ? <LoginPage /> : <TrainingDsd />,
        },
        {
          path: 'trainingCertificate',
          element: !cookies.session ? <LoginPage /> : <TrainingCertificate />,
        },
        {
          path: 'evaluationSkillGap',
          element: !cookies.session ? <LoginPage /> : <EvaluationSkillGap />,
        },
        {
          path: 'talentNineBox',
          element: !cookies.session ? <LoginPage /> : <TalentNineBox />,
        },
        {
          path: 'evaluationRetention',
          element: !cookies.session ? <LoginPage /> : <EvaluationRetention />,
        },
        {
          path: 'evaluationOkr',
          element: !cookies.session ? <LoginPage /> : <EvaluationOkr />,
        },
        {
          path: 'evaluationPeerSummary',
          element: !cookies.session ? <LoginPage /> : <EvaluationPeerSummary />,
        },
        {
          path: 'boonsiriConnect',
          element: !cookies.session ? <LoginPage /> : <BoonsiriConnect />,
        },
        {
          path: 'baiboonAdmin',
          element: !cookies.session ? <LoginPage /> : <BaiboonAdmin />,
        },
        {
          path: 'dataGovernance',
          element: !cookies.session ? <LoginPage /> : <DataGovernance />,
        },
        {
          path: 'otCosting',
          element: !cookies.session ? <LoginPage /> : <OtCosting />,
        },
        {
          path: 'resignationList',
          element: !cookies.session ? <LoginPage /> : <ResignationList />,
        },
        { path: 'listSignup', element: !cookies.session ? <LoginPage /> : <ListSignUp /> },
        { path: 'candidate', element: !cookies.session ? <LoginPage /> : <Candidate /> },
        {
          path: 'organizationalChart',
          element: !cookies.session ? <LoginPage /> : <OrganizationalChart />,
        },
        { path: 'probationEva', element: !cookies.session ? <LoginPage /> : <ProbationEva /> },
        { path: 'probationEvaMe', element: !cookies.session ? <LoginPage /> : <ProbationEvaMe /> },
        {
          path: 'probationEvaYear',
          element: !cookies.session ? <LoginPage /> : <ProbationEvaYear />,
        },
        {
          path: 'probationEvaYearMe',
          element: !cookies.session ? <LoginPage /> : <ProbationEvaYearMe />,
        },
        { path: 'reportResign', element: !cookies.session ? <LoginPage /> : <ReportResign /> },
        { path: 'favoriteJob', element: !cookies.session ? <LoginPage /> : <FavoriteJob /> },
        { path: 'orientation', element: !cookies.session ? <LoginPage /> : <Orientation /> },
        {
          path: 'reportEvaluation',
          element: !cookies.session ? <LoginPage /> : <ReportEvaluation />,
        },
        { path: 'claim', element: !cookies.session ? <LoginPage /> : <Claim /> },
        { path: 'reward', element: !cookies.session ? <LoginPage /> : <Reward /> },
        {
          path: 'dashboardProbationEva',
          element: !cookies.session ? <LoginPage /> : <DashboardProbationEva />,
        },
        {
          path: 'dashboardProbationEvaYear',
          element: !cookies.session ? <LoginPage /> : <DashboardProbationEvaYear />,
        },
        { path: 'reportEmployee', element: !cookies.session ? <LoginPage /> : <ReportEmployee /> },
        { path: 'manageAssets', element: !cookies.session ? <LoginPage /> : <ManageAssets /> },
        { path: 'manageChatId', element: !cookies.session ? <LoginPage /> : <ManageChatId /> },
        {
          path: 'testProbationEva',
          element: !cookies.session ? <LoginPage /> : <TestProbationEva />,
        },
        {
          path: 'testProbationEvaYear',
          element: !cookies.session ? <LoginPage /> : <TestProbationEvaYear />,
        },
        { path: 'employee/:id', element: !cookies.session ? <LoginPage /> : <Employee /> },
        {
          path: 'testTalentAssessment',
          element: !cookies.session ? <LoginPage /> : <TestTalentAssessment />,
        },
        { path: 'cardBusiness', element: !cookies.session ? <LoginPage /> : <CardBusiness /> },
        // { path: 'test', element: !cookies.session?<LoginPage/>:<Test /> },
        {
          path: 'promoteCandidate',
          element: !cookies.session ? <LoginPage /> : <PromoteCandidate />,
        },
      ],
    },
    {
      path: 'login',
      element: !cookies.session ? <LoginPage /> : <IndexPage />,
    },
    {
      path: 'test',
      element: <Test />,
    },
    {
      path: 'resume/:id',
      element: <Resume />,
    },
    {
      path: '404',
      element: <Page404 />,
    },

    {
      path: 'loginCandidate',
      element: <LoginCandidate />,
    },
    {
      path: 'registerCandidate',
      element: <RegisterCandidate />,
    },
    {
      path: 'emCardBusiness/:id',
      element: <EMCardBusiness />,
    },
    { path: 'resetPassword', element: <ResetPassword /> },

    // {
    //   path: 'testProbationEva',
    //   element: <TestProbationEva />,
    // },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
